import { Injectable } from '@angular/core';
import { Action, State, StateContext } from '@ngxs/store';
import { ModelActionsModal } from '@models-global/model-actions';
import { IClaimAuditStatusUpdateParams } from '@module-claims/models/claim.interface';
import {
  ActionClaimModalAuditStatusClose,
  ActionClaimModalAuditStatusSave
} from './claims-modal.actions';

export interface IClaimAuditStatusModalState {
  readonly action?: ModelActionsModal;
  readonly data?: IClaimAuditStatusUpdateParams;
}

@State<IClaimAuditStatusModalState>({
  name: 'ClaimAuditStatusModalState',
  defaults: {
    action: undefined,
    data: undefined
  }
})
@Injectable()
export class ClaimAuditStatusModalState {
  @Action(ActionClaimModalAuditStatusSave)
  saveModal(
    ctx: StateContext<IClaimAuditStatusModalState>,
    { params }: ActionClaimModalAuditStatusSave
  ): void {
    ctx.patchState({
      action: 'save',
      data: params
    });
  }

  @Action(ActionClaimModalAuditStatusClose)
  closeModal(ctx: StateContext<IClaimAuditStatusModalState>): void {
    ctx.patchState({
      action: 'close',
      data: undefined
    });
  }
}
